import Button from 'jd-library/Button';
import historyHandler from 'jd-library/historyHandler';
import Modal from 'jd-library/Modal';
import React from 'react';
import styles from './add-edit-product.scss';
import { isSafari } from '../../utills';

export const AuditPendingModal = props => {
	return (
		<Modal
			settings={{
				modalId: 'DocReqProduct',
				variant: 'action',
				class: styles['document-required-modal']
			}}
			backdropStatic={true}
			onHidden={props.onHidden}
		>
			{/* <Modal.CloseIcon /> */}
			<div className={styles['document-required-body']}>
				<div className={styles['heading']}>Audit Pending</div>
				<div
					className={`${styles['document-required-message']} ${styles['audit-pending']}`}
				>
					Your product will be reviewed by our moderation team within
					72 hours before it goes live
				</div>
			</div>
			<div className={styles['audit-pending-btn']}>
				<Button
					size='lg'
					block
					clickHandler={() => {
						if(props.isMobile){
							historyHandler.closeCurrent();
							let safari = isSafari();
							if((!props.isChrome && safari) || props.isIPhone) {
							   setTimeout(() => {
								 historyHandler.closeCurrent();
							   }, 100);
							}
						 }  
						props.gotClicked();
					}}
				>
					{'Okay, Got it'}
				</Button>
			</div>
		</Modal>
	);
};
